import { Component, OnInit, Input, Output, EventEmitter, } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray, } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { DataserviceService } from 'src/app/dataservice.service';

@Component({
  selector: 'app-dish-equipment',
  templateUrl: './dish-equipment.component.html',
  styleUrl: './dish-equipment.component.css'
})
export class DishEquipmentComponent implements OnInit {
  @Input() fullData: any;
  @Output() chosenEquipment = new EventEmitter<any>();

  planForm: FormGroup;

  devices: any;
  devices2: any;
  addingEquipment: boolean = false;
  loadingId: any;

  constructor(
    private data: DataserviceService,
    private message: NzMessageService,
    private fb: FormBuilder,
  ) {

    this.planForm = this.fb.group({
      mainTopBox: ['', Validators.required],
      secondaryBox: [''],
      additionalBoxes: this.fb.array([])
    });

  }

  ngOnInit() {
    console.log(this.fullData.conversationId)
    this.getEquipment();
  }

  getEquipment() {
    this.message.remove(this.loadingId);
    this.loadingId = this.message.loading('Getting equipment...', { nzDuration: 0 }).messageId;
    this.data.postDataNoBodyDotBody({ conversationId: this.fullData.conversationId }, 'dish/equipment').subscribe((r: any) => {
      const receivers = r.data?.GetEquipmentSelectionsResponse?.EquipmentSolution || [];

      const flatDevices = receivers.flatMap((group: any) =>
        group.SolutionLineItem.map((r: any) => ({
          value: r.ReceiverId,
          display: r.Description
        }))
      );

      this.devices = flatDevices.filter((d: any) => d.display?.toLowerCase() != 'total');

      console.log(this.devices)

      const receivers2 = r.data?.GetEquipmentSelectionsResponse?.ReceiversSolution?.CustomReceivers || [];

      const flatDevices2 = receivers2.flatMap((group: any) =>
        group.Receiver.map((r: any) => ({
          value: r.ReceiverId,
          display: r.ModelName
        }))
      );

      this.devices2 = flatDevices2;

      if(this.fullData.equipment?.obj) {
        const fa = this.planForm.get('additionalBoxes') as FormArray;

        this.planForm.patchValue({
          mainTopBox: this.fullData.equipment?.obj.mainTopBox,
          secondaryBox: this.fullData.equipment?.obj.secondaryBox,
          additionalBoxes: this.fullData.equipment?.obj.additionalBoxes?.forEach((e: any) => fa.push(new FormControl(e)))
        });

        this.planForm.updateValueAndValidity();

      }

      const hopperPlus = this.devices?.find((device: any) => device.display?.toLowerCase() === 'hopper plus');
      const mainTopBoxControl = this.planForm.get('mainTopBox');
      if (!this.fullData?.equipment?.obj?.mainTopBox && hopperPlus && !mainTopBoxControl?.value) {
        mainTopBoxControl?.setValue(hopperPlus.value);
      }

      this.message.remove(this.loadingId);
    });
  }

  get additionalBoxes() {
    return this.planForm.get('additionalBoxes') as FormArray;
  }

  addBox(): void {
    this.additionalBoxes.push(this.fb.control('', Validators.required));
  }

  removeBox(index: number): void {
    this.additionalBoxes.removeAt(index);
  }

  submit() {
    this.addingEquipment = true;
    this.message.remove(this.loadingId);
    this.loadingId = this.message.loading('Submitting equipment...', { nzDuration: 0 }).messageId;
    const selectedMain = this.planForm.value.mainTopBox;
    const selectedSecondary = this.planForm.value.secondaryBox;
    const additional = this.planForm.value.additionalBoxes || [];

    const obj = this.planForm.value;

    const selectedReceiverIds = [selectedMain, selectedSecondary, ...additional];

    const payload = {
      leadId: this.fullData.qual.leadId,
      conversationId: this.fullData.conversationId,
      selectedReceiverIds
    };

    this.data.postDataNoBodyDotBody(
      {
        woId: this.fullData.woId,
        id: this.fullData.customerId,
        generic: {
          selectedEquipment: selectedReceiverIds
        }
      },
      'work-order/update-generic'
    ).subscribe({
      next: () => {
        this.data.postDataNoBodyDotBody(payload, 'dish/validateEquipment').subscribe({
          next: (r: any) => {
            this.message.remove(this.loadingId);
            if (r.result === 'success') {
              this.addingEquipment = false;
              this.chosenEquipment.emit({ ...payload, obj });
            } else {
              this.addingEquipment = false;
              alert('Validation failed: ' + (r.message || 'Unknown error'));
            }
          },
          error: (err: any) => {
            console.error('Equipment validation failed', err);
            this.message.remove(this.loadingId);
            this.addingEquipment = false;
            alert('Failed to validate equipment. Please try again.');
          }
        });
      },
      error: (e: any) => {
        console.error('Failed to update work order with equipment', e);
        this.message.remove(this.loadingId);
        this.addingEquipment = false;
        alert('Failed to save equipment selection. Please try again.');
      }
    });
  }
}
